(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../_util/render", "../_util", "../_mixins/relation", "../_mixins/resizeOb", "animejs"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../_util/render"), require("../_util"), require("../_mixins/relation"), require("../_mixins/resizeOb"), require("animejs"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.render, global._util, global.relation, global.resizeOb, global.animejs);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _render, _util, _relation, _resizeOb, _animejs) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _animejs = _interopRequireDefault(_animejs);

  function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  var PAGING_SCALE = 0.5;
  var PAGING_DURATION = 300;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        ref: "wrapper",
        staticClass: "nx-swiper",
        class: {
          'nx-swiper-vertical': _vm.isVertical,
          'nx-swiper-fade': !_vm.isSlide,
          'nx-swiper-round': _vm.round,
          disabled: !_vm.isInitial
        },
        on: {
          "mousedown": _vm.$_onDragStart,
          "mousemove": _vm.$_onDragMove,
          "mouseup": _vm.$_onDragEnd,
          "mouseleave": _vm.$_onDragEnd,
          "touchstart": _vm.$_onDragStart,
          "touchmove": _vm.$_onDragMove,
          "touchend": _vm.$_onDragEnd,
          "touchcancel": _vm.$_onDragEnd
        }
      }, [_c('div', {
        staticClass: "nx-swiper-box"
      }, [_c('div', {
        ref: "container",
        staticClass: "nx-swiper-container",
        style: [_vm.swiperStyle]
      }, [_vm._t("default")], 2)]), _vm.oItemCount > 1 && _vm.hasDots ? _c('div', {
        staticClass: "nx-swiper-indicators",
        class: {
          disabled: !_vm.hasDots
        }
      }, [_vm._l(_vm.oItemCount, function (index) {
        return [_c('div', {
          key: index,
          staticClass: "nx-swiper-indicator",
          class: [{
            'nx-swiper-indicator-active': index - 1 === _vm.realIndex
          }, "nx-swiper-indicator-order-" + (index - 1)]
        })];
      })], 2) : _vm._e()]);
    },
    name: 'nx-swiper',
    mixins: [(0, _relation.ParentMixin)('nxSwiper'), _resizeOb.resizeOb],
    props: {
      autoplay: {
        type: Number,
        default: 3000,
        validator: function validator(value) {
          if (value === 0) {
            return true;
          }

          return value >= 500;
        }
      },
      // 用于控制大的变化
      transition: {
        type: String,
        default: 'slide',
        validator: function validator(value) {
          return ['slide', 'slideY', 'fade', 'card-slide'].indexOf(value) > -1;
        }
      },
      // 大的变化确认完以后，用于控制小的动画模式
      animation: {
        type: String,
        default: 'turning',
        validator: function validator(value) {
          return ['tab-slide', 'turning'].indexOf(value) > -1;
        }
      },
      transitionDuration: {
        type: Number
      },
      defaultIndex: {
        // display index
        type: Number,
        default: 0,
        validator: function validator(value) {
          return value > -1;
        }
      },
      hasDots: {
        type: Boolean,
        default: true
      },
      isPrevent: {
        type: Boolean,
        default: true
      },
      isLoop: {
        type: Boolean,
        default: true
      },
      dragable: {
        type: Boolean,
        default: true
      },
      useNativeDriver: {
        type: Boolean,
        default: true
      },
      round: {
        type: Boolean,
        default: false
      },
      // 无障碍兼容，开启时会主动调用focus，可能会在某些机型上导致页面自动滑动问题
      ariaSwiperFocus: {
        type: Boolean,
        default: false
      },
      autoResize: {
        type: Boolean,
        default: true
      },
      isDragRebound: {
        type: Boolean,
        default: false
      },
      // 内部属性
      tabSlideMode: {
        type: String
      },
      // 仅在非循环、card-slide模式下使用
      initialSlideOffset: {
        type: Number
      }
    },
    data: function data() {
      return {
        ready: false,
        dragging: false,
        userScrolling: null,
        isInitial: false,
        dragToIndex: 0,
        index: 0,
        // real index (swiper perspective)
        fromIndex: 0,
        // display index (user perspective)
        toIndex: 0,
        // display index
        firstIndex: 0,
        // display index
        lastIndex: 0,
        // display index
        oItemCount: 0,
        // original item count
        rItemCount: 0,
        // real item count
        dimension: 0,
        touchAngle: 45,
        moveSpeed: 0,
        moveOffsetPercent: 0,
        dragState: {},
        timer: null,
        noDrag: false,
        scroller: null,
        isStoped: false,
        $swiper: null,
        transitionEndHandler: null,
        resizeOb: null,
        preOffset: 0,
        // 记录上次的位置，用于回弹效果
        // transitionSlideX: { transition: `transform 350ms cubic-bezier(0.28, 0.4, 0.2, 1)` },
        transitionSlideX: {},
        containerHeight: 0,
        resizeNumber: 0,
        // 用于记录调整尺寸的上限
        updateStatus: false,
        bounceStatus: false,
        // inAnimation: false,
        anime: null,
        transitionDurationInside: 0
      };
    },
    computed: {
      isLastItem: function isLastItem() {
        return this.index === this.rItemCount - 1;
      },
      isFirstItem: function isFirstItem() {
        return this.index === 0;
      },
      realIndex: function realIndex() {
        return this.getIndex();
      },
      isTabSlide: function isTabSlide() {
        return this.transition === 'slide' && this.animation === 'tab-slide';
      },
      isTurning: function isTurning() {
        return ['slide', 'card-slide'] && this.animation === 'turning';
      },
      isSlide: function isSlide() {
        return this.transition.toLowerCase().indexOf('slide') > -1;
      },
      isVertical: function isVertical() {
        return this.transition === 'slideY';
      },
      isCardSlide: function isCardSlide() {
        return this.transition === 'card-slide';
      },
      isNoLoopAndDragRebound: function isNoLoopAndDragRebound() {
        return !this.isLoop && this.isDragRebound;
      },
      swiperStyle: function swiperStyle() {
        if (this.tabSlideMode === 'halfPage') {
          var height = this.containerHeight;
          return height ? {
            alignItems: 'flex-start',
            height: "".concat(height, "px")
          } : {
            alignItems: 'flex-start'
          };
        } else {
          return {};
        }
      }
    },
    watch: {
      transition: function transition(_new) {
        var _this = this;

        // 切换时，需要重新触发
        if (_new) {
          this.$nextTick(function () {
            _this.$_reInitItems();

            _this.$_startPlay();
          });
        }
      },
      dragable: function dragable(val) {
        this.noDrag = !val;
      },
      dragging: function dragging(val) {
        if (!val) {
          this.renderIndicatorsOpacity();
        }
      }
    },
    // LiftCircle Hook

    /*
    beforeCreate
    created
    beforeMount
    */
    mounted: function mounted() {
      var _this2 = this;

      // console.log('swiper mounted')
      this.ready = true;
      this.$swiper = this.$el.querySelector('.nx-swiper-container');
      this.$swiperBox = this.$el.querySelector('.nx-swiper-box');
      this.$nextTick(function () {
        _this2.$_reInitItems();

        _this2.$_startPlay();

        window.addEventListener('resize', _this2.$_resize);
        document.addEventListener('visibilitychange', _this2.$_visibilitychange);
      });
      this.processWrapperWidthChange();
    },
    updated: function updated() {
      var _this3 = this;

      if (this.updateStatus) return;
      this.updateStatus = true; // 对于异步返回的数据，处理item的高度

      this.$nextTick(function () {
        if (_this3.tabSlideMode === 'halfPage') {
          var el = _this3.$children[_this3.index] && _this3.$children[_this3.index].$el;
          var height = el[_this3.vertical ? 'offsetWidth' : 'offsetHeight'];
          if (height !== _this3.containerHeight) _this3.containerHeight = height;
        }

        _this3.updateStatus = false;
      });
    },

    /*
    beforeUpdate
    updated
    activated
    deactivated
    beforeDestroy
    */
    destroyed: function destroyed() {
      this.ready = false;
      this.$_clearTimer();
      window.removeEventListener('resize', this.$_resize);
      document.removeEventListener('visibilitychange', this.$_visibilitychange);

      if (this.__resizeTimeout__) {
        clearTimeout(this.__resizeTimeout__);
      }

      this.unprocessWrapperWidthChange(); // 重置，否则有问题

      !this.isSlide && this.$children.forEach(function (item) {
        if (item && item.$el) item.$el.style.opacity = '';
      });
    },

    /*
    errorCaptured
    */
    methods: {
      // MARK: private methods
      $_resize: function $_resize() {
        var _this4 = this;

        // console.log('$_resize')
        // 防止屏幕翻转时，容器的尺寸更改不及时导致异常
        if (this.__resizeTimeout__) {
          clearTimeout(this.__resizeTimeout__);
        }

        this.__resizeTimeout__ = setTimeout(function () {
          _this4.$_reInitItems();
        }, 300);
      },
      // 切到后台时，暂停自动轮播
      $_visibilitychange: function $_visibilitychange() {
        if (this.autoplay !== 0) {
          if (document.hidden) {
            this.stop();
          } else {
            this.play(this.autoplay);
          }
        }
      },
      $_onDragStart: function $_onDragStart(e) {
        /**
         * Consume unfinished transition handler first
         * Otherwise the offset calculation will be abnormal
         */
        this.destroyAnime(); // if (this.inAnimation) return

        if (this.isPrevent) {
          e.cancelable && e.preventDefault();
        }

        this.dragging = true;
        this.userScrolling = null; // 设置滑动动效
        // this.$_changeTransitionMode(false)

        this.$_doOnTouchStart(e);
      },
      $_onDragMove: function $_onDragMove(e) {
        // if (this.inAnimation) return
        if (this.isPrevent) {
          e.cancelable && e.preventDefault();
        }

        if (!this.dragging) {
          return;
        } // this.$_changeTransitionMode(false)


        this.$_doOnTouchMove(e);
      },
      $_onDragEnd: function $_onDragEnd(e) {
        // if (this.inAnimation) return
        if (this.isPrevent) {
          e.cancelable && e.preventDefault();
        } // 如果拖动的方向不对，则不执行


        if (this.userScrolling) {
          this.play(this.autoplay);
          this.dragging = false;
          this.dragState = {};
          return;
        }

        if (!this.dragging) {
          return;
        } // this.$_changeTransitionMode()


        this.$_doOnTouchEnd(e);
        this.$_ariaSwiperFocus(true);
        this.dragging = false;
      },
      $_ariaSwiperFocus: function $_ariaSwiperFocus() {
        var _this5 = this;

        var drag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        // 如果有自动轮播 或者 不可拖动，则不触发
        if (this.autoplay > 0) return; // 无障碍-拖动以后聚焦

        this.$nextTick(function () {
          _this5.$children.forEach(function (item) {
            if (item.$el) {
              item.$el.ariaHidden = 'true';
            }
          });

          var to = _this5.$children[_this5.realIndex].$el;
          to.ariaHidden = 'false';

          if (drag && _this5.ariaSwiperFocus && !_this5.noDrag) {
            // 动画结束以后才执行focus
            setTimeout(function () {
              to && to.focus();
            }, 350);
          }
        });
      },
      $_getDimension: function $_getDimension() {
        if (this.isCardSlide) {
          // card 滑动模式，用于折叠屏
          this.dimension = this.$children[0] && this.$children[0].$el.offsetWidth || 0;
          this.slideOffset = (this.$swiper.clientWidth - this.dimension) / 2;
        } else {
          // 其他模式
          this.dimension = this.isVertical ? this.$el.clientHeight : this.$el.clientWidth;
          this.slideOffset = 0;
        }
      },
      _cloneClickEventInVue: function _cloneClickEventInVue(copyEl, el) {
        if (!el) return; // 传入到swiper-item上的onClickEvent属性

        if (el && el.onClickEvent) {
          copyEl.addEventListener('click', el.onClickEvent);
        }
      },
      $_backupItem: function $_backupItem(children) {
        if (!this.isLoop || children.length <= 1) return;
        var firstNode = children[0].$el.cloneNode(true);
        var lastNode = children[children.length - 1].$el.cloneNode(true); // 卡片且循环模式，需要复制click事件

        if (this.isCardSlide && this.isLoop) {
          this._cloneClickEventInVue(firstNode, children[0]);

          this._cloneClickEventInVue(lastNode, children[children.length - 1]);
        }

        var firstNodeCopy = this.$swiper.querySelector('.nx-swiper-item-first-copy');
        var lastNodeCopy = this.$swiper.querySelector('.nx-swiper-item-last-copy');
        firstNodeCopy && this.$swiper.removeChild(firstNodeCopy);
        lastNodeCopy && this.$swiper.removeChild(lastNodeCopy);
        firstNode.className += ' nx-swiper-item-first-copy';
        lastNode.className += ' nx-swiper-item-last-copy';

        if (this.isVertical) {
          firstNode.style.height = "".concat(this.dimension, "px");
          lastNode.style.height = "".concat(this.dimension, "px");
        } else if (this.isCardSlide) {
          firstNode.style.width = "auto";
          lastNode.style.width = "auto";
        } else {
          firstNode.style.width = "".concat(this.dimension, "px");
          lastNode.style.width = "".concat(this.dimension, "px");
        } // 无障碍模式下不可选中


        firstNode.ariaHidden = true;
        lastNode.ariaHidden = true;
        this.$swiper.appendChild(firstNode);
        this.$swiper.insertBefore(lastNode, this.$swiper.childNodes[0]);
        if (lastNodeCopy && firstNodeCopy) return;
        this.firstIndex++;
        this.lastIndex++;
        this.index++;
        this.rItemCount += 2;
      },
      $_animeTranslate: function $_animeTranslate(_ref) {
        var _this6 = this;

        var element = _ref.element,
            offset = _ref.offset,
            cb = _ref.cb,
            closeAnimation = _ref.closeAnimation;

        if (!element) {
          (0, _util.warn)('[nx-swiper] no element for anime translate');
          return;
        } // 对于非循环且非回弹的情况，到了边缘以后不允许往回拉


        if (!this.isLoop && !this.isDragRebound) {
          if (offset > this.slideOffset) return;
          if (offset < this.slideOffset - this.lastIndex * this.dimension) return;
        } // if (this.inAnimation) return


        if (closeAnimation) {
          var x = this.isVertical ? 0 : offset;
          var y = this.isVertical ? offset : 0;
          (0, _render.renderSimple)({
            content: this.$swiper,
            left: x,
            top: y,
            useNativeDriver: this.useNativeDriver
          });
          return;
        }

        var options = this.isVertical ? {
          translateY: offset
        } : {
          translateX: offset
        };
        options = this.useNativeDriver ? _objectSpread(_objectSpread({}, options), {}, {
          translateZ: 0
        }) : options; // this.inAnimation = true

        this.anime = (0, _animejs.default)(_objectSpread(_objectSpread({}, options), {}, {
          targets: this.$swiper,
          autoplay: true,
          duration: this.transitionDuration || this.transitionDurationInside || this.getTransitionParams({
            type: 'duration'
          }),
          easing: this.getTransitionParams({
            type: 'easing'
          }),
          complete: function complete() {
            _this6.destroyAnime(); // this.inAnimation = false


            cb && cb();
          }
        }));
      },
      destroyAnime: function destroyAnime() {
        var _this$anime, _this$anime2;

        // 重置速度
        this.moveSpeed = 0;
        this.moveOffsetPercent = 0;
        this.transitionDurationInside = 0; // 重置anime

        (_this$anime = this.anime) === null || _this$anime === void 0 ? void 0 : _this$anime.pause();
        (_this$anime2 = this.anime) === null || _this$anime2 === void 0 ? void 0 : _this$anime2.remove(this.$swiper);
        this.anime = null;
      },
      $_opacity: function $_opacity() {
        var _this7 = this;

        var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var opacity = arguments.length > 1 ? arguments[1] : undefined;

        if (typeof opacity !== 'undefined') {
          var toIndex = 0;
          var fromIndex = this.toIndex;
          var itemCount = this.rItemCount;

          if (opacity > 0) {
            if (fromIndex > 0) {
              toIndex = fromIndex - 1;
            } else if (fromIndex === 0) {
              toIndex = itemCount - 1;
            }
          } else {
            if (fromIndex < itemCount - 1) {
              toIndex = fromIndex + 1;
            } else if (fromIndex === itemCount - 1) {
              toIndex = 0;
            }
          }

          var _from = this.$children[fromIndex].$el;
          var _to = this.$children[toIndex].$el;
          _from.style.opacity = 1 - Math.abs(opacity);
          _from.style.transition = animate ? 'opacity 300ms ease' : '';
          _to.style.opacity = Math.abs(opacity);
          return;
        }

        var from = this.$children[this.fromIndex].$el;
        var to = this.$children[this.toIndex].$el;
        from.style.opacity = 0;
        from.style.transition = animate ? 'opacity 500ms ease' : '';
        to.style.opacity = 1;

        if (animate) {
          setTimeout(function () {
            _this7.$emit('after-change', _this7.fromIndex, _this7.toIndex);
          }, 500);
        }
      },
      $_initState: function $_initState(children) {
        this.oItemCount = children.length;
        this.rItemCount = children.length;
        this.noDrag = children.length === 1 || !this.dragable;
        this.index = this.defaultIndex >= 0 && this.defaultIndex < children.length ? parseInt(this.defaultIndex) : 0;
        this.firstIndex = 0;
        this.lastIndex = children.length - 1;
        this.fromIndex = this.index === this.firstIndex ? this.lastIndex : this.index + 1;
        this.toIndex = this.index;
        this.$_ariaSwiperFocus();
      },
      $_reInitItems: function $_reInitItems() {
        var children = this.$children;

        if (!children || !children.length) {
          return;
        }

        this.$_getDimension(); // 如果已经滑动了一部分，在resize的时候，不再初始化状态

        if (this.index === 0) this.$_initState(children);

        if (this.isSlide) {
          // console.log('调用了两次$_reInitItems')
          this.$_backupItem(children);
          this.$_animeTranslate({
            element: this.$swiper,
            offset: this.$_getOffset(),
            closeAnimation: true
          }); // this.$_translate(this.$swiper, this.slideOffset - this.dimension * this.index)
        } else {
          this.$_opacity(false);
        }

        this.isInitial = true;
      },
      $_startPlay: function $_startPlay() {
        var _this8 = this;

        if (this.autoplay > 0 && this.oItemCount > 1) {
          this.$_clearTimer();
          this.timer = setInterval(function () {
            if (!_this8.isLoop && _this8.index >= _this8.rItemCount - 1) {
              return _this8.$_clearTimer();
            }

            if (!_this8.dragging) {
              // this.$_changeTransitionMode()
              _this8.next();
            }
          }, this.autoplay);
        }
      },
      $_clearTimer: function $_clearTimer() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      },
      $_isScroll: function $_isScroll(dragState, diffX, diffY) {
        var vertical = this.isVertical;
        var currentLeft = dragState.currentLeft,
            currentTop = dragState.currentTop,
            startLeft = dragState.startLeft,
            startTop = dragState.startTop;

        if (this.userScrolling === null) {
          if (!vertical && currentTop === startTop || vertical && currentLeft === startLeft) {
            return false;
          } else {
            /* istanbul ignore next */
            if (diffX * diffX + diffY * diffY >= 25) {
              var _touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;

              return !vertical ? _touchAngle > this.touchAngle : 90 - _touchAngle > this.touchAngle;
            } else {
              return false;
            }
          }
        }

        return this.userScrolling;
      },
      // real index => display index
      $_calcDisplayIndex: function $_calcDisplayIndex(index) {
        if (this.isLoop && this.isSlide && this.oItemCount > 0) {
          return index - 1 < 0 ? this.oItemCount - 1 : index - 1 > this.oItemCount - 1 ? 0 : index - 1;
        }

        return index;
      },
      $_getOffset: function $_getOffset() {
        var _offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.slideOffset - this.dimension * this.index;

        // let _offset = this.slideOffset - this.dimension * this.index
        if (this.$children.length < 2) return _offset;

        if (this.isFirstItem && !this.isLoop && this.initialSlideOffset !== undefined) {
          // 去掉this.slideOffset，用替代
          return this.initialSlideOffset + _offset - this.slideOffset;
        }

        if (this.isLastItem && !this.isLoop && this.initialSlideOffset !== undefined) {
          return this.slideOffset + _offset - this.initialSlideOffset;
        }

        return _offset;
      },
      // display index => real index
      $_calcuRealIndex: function $_calcuRealIndex(index) {
        if (index < 0) {
          index = 0;
        } else if (this.oItemCount > 0 && index > this.oItemCount - 1) {
          index = this.oItemCount - 1;
        }

        if (this.isLoop && this.isSlide) {
          return index + 1;
        }

        return index;
      },
      $_doTransition: function $_doTransition(towards, options) {
        var _this9 = this;

        if (this.oItemCount === 0) {
          return;
        }

        if (!options && this.oItemCount < 2) {
          return;
        }

        if (!towards) {
          return;
        }

        var index = this.index;
        var itemCount = this.rItemCount;
        var oldIndex = this.index;

        if (options && options.index !== undefined) {
          this.index = options.index;
        } else if (towards === 'prev') {
          if (index > 0) {
            this.index = index - 1;
          } else if (!this.isSlide && index === 0) {
            this.index = itemCount - 1;
          } else if (this.isLoop && index === 0) {
            this.index = itemCount - 1;
          }
        } else if (towards === 'next') {
          if (index < itemCount - 1) {
            this.index = index + 1;
          } else if (!this.isSlide && index === itemCount - 1) {
            this.index = 0;
          } else if (this.isLoop && index === itemCount - 1) {
            this.index = 1;
          }
        }

        if (this.isLoop && this.isSlide) {
          this.fromIndex = this.$_calcDisplayIndex(oldIndex);
          this.toIndex = this.$_calcDisplayIndex(this.index);
        } else {
          this.fromIndex = this.toIndex;
          this.toIndex = this.index;
        }

        this.$emit('before-change', this.fromIndex, this.toIndex);

        if (!this.isSlide) {
          this.$_opacity();
          return;
        }

        var isFirstItem = this.isFirstItem && this.isLoop;
        var isLastItem = this.isLastItem && this.isLoop;

        var handler = function handler() {
          // this.$_changeTransitionMode(false)
          // Recover first and last page
          if (isLastItem) {
            var offset = -_this9.firstIndex * _this9.dimension + (_this9.isVertical ? 0 : _this9.slideOffset);

            _this9.$_animeTranslate({
              element: _this9.$swiper,
              offset: offset,
              closeAnimation: true
            });
          }

          if (isFirstItem) {
            var _offset2 = -_this9.lastIndex * _this9.dimension + (_this9.isVertical ? 0 : _this9.slideOffset);

            _this9.$_animeTranslate({
              element: _this9.$swiper,
              offset: _offset2,
              closeAnimation: true
            });
          }

          _this9.$emit('after-change', _this9.fromIndex, _this9.toIndex);
        };

        var _offset = this.$_getOffset();

        this.$_animeTranslate({
          element: this.$swiper,
          offset: _offset,
          cb: handler
        });
        this.$emit('posChange', 0);
        this.bounceStatus = false; // Recover first and last indicator

        if (isFirstItem) {
          this.index = this.lastIndex;
        } else if (isLastItem) {
          this.index = this.firstIndex;
        }
      },
      $_doOnTouchStart: function $_doOnTouchStart(event) {
        if (this.noDrag) {
          return;
        }

        this.stop();
        var element = this.$el;
        var dragState = this.dragState;
        var point = event.changedTouches ? event.changedTouches[0] : event; // 记录本次的触点

        this.prev = point.pageX; // 记录touchId

        this.touchId = point.identifier;
        dragState.startTime = new Date();
        dragState.startLeft = point.pageX;
        dragState.startTop = point.pageY;
        dragState.itemWidth = this.isCardSlide ? this.dimension : element.offsetWidth;
        dragState.itemHeight = element.offsetHeight;
      },
      $_doOnTouchMove: function $_doOnTouchMove(event) {
        var _this10 = this,
            _event$changedTouches;

        if (this.noDrag) {
          return;
        }

        var point = event.changedTouches ? event.changedTouches[0] : event; // 非同一触点，忽略操作；如果是鼠标触发，直接转换

        var isTouchExist = event.changedTouches ? [].slice.call(event.changedTouches).filter(function (touch) {
          return touch.identifier === _this10.touchId;
        })[0] : true; // 禁止多个触点

        if (!isTouchExist || ((_event$changedTouches = event.changedTouches) === null || _event$changedTouches === void 0 ? void 0 : _event$changedTouches.length) > 1) {
          event.preventDefault();
          return;
        }

        var dragState = this.dragState;
        dragState.currentLeft = point.pageX;
        dragState.currentTop = point.pageY;
        var offsetLeft = dragState.currentLeft - dragState.startLeft,
            delta = this.prev - dragState.currentLeft;

        if (this.bounceStatus) {
          offsetLeft = this.preOffset - delta;
        }

        var offsetTop = dragState.currentTop - dragState.startTop;
        this.userScrolling = this.$_isScroll(dragState, Math.abs(offsetLeft), Math.abs(offsetTop));

        if (this.userScrolling) {
          return;
        } else {
          event.cancelable && event.preventDefault();
        } // 不循环时，如果在边界继续往边缘方向拉，就给滑动添加阻尼效果


        if (this.isNoLoopAndDragRebound) {
          // delta为0的情况经常发生，直接忽略，不做移动即可
          // if (delta === 0) return
          // 首尾做回弹效果
          if (this.index <= 0 && delta < 0 || this.index >= this.$children.length - 1 && delta > 0) {
            // 快速滑动时，每次delta会很大，所以能起到阻尼的效果；慢慢拖动时，每次delta比较小。
            // delta = delta > 0 ? Math.min(delta, 5) : Math.max(delta, -5)
            delta = delta * (1 - Math.abs(this.preOffset / dragState.itemWidth)) * 0.5;
            offsetLeft = this.preOffset - delta;
            this.bounceStatus = true;
          } // 手指移动的距离


          this.prev = dragState.currentLeft;
        }

        var _offsetLeft = Math.min(Math.max(-dragState.itemWidth + 1, offsetLeft), dragState.itemWidth - 1);

        var _offsetTop = Math.min(Math.max(-dragState.itemHeight + 1, offsetTop), dragState.itemHeight - 1);

        var offset = this.isVertical ? _offsetTop - dragState.itemHeight * this.index : _offsetLeft - dragState.itemWidth * this.index;
        var pos = -_offsetLeft / dragState.itemWidth;
        this.$emit('posChange', pos);
        this.dragToIndex = this.$_calcDisplayIndex(pos > 0 ? this.index + 1 : this.index - 1);
        requestAnimationFrame(function () {
          _this10.renderIndicatorsOpacity(pos);
        });

        if (this.isCardSlide) {
          // 卡片模式需要增加偏移值
          this.$_animeTranslate({
            element: this.$swiper,
            offset: this.$_getOffset(offset + this.slideOffset),
            closeAnimation: true
          }); // this.$_translate(this.$swiper, offset + this.slideOffset)
        } else if (this.isSlide) {
          this.$_animeTranslate({
            element: this.$swiper,
            offset: offset,
            closeAnimation: true
          }); // this.$_translate(this.$swiper, offset)
        } else {
          this.$_opacity(false, offsetLeft / dragState.itemWidth);
        } // banner 移动的距离


        this.isNoLoopAndDragRebound && (this.preOffset = _offsetLeft);
      },
      $_doOnTouchEnd: function $_doOnTouchEnd() {
        if (this.noDrag) {
          return;
        }

        var dragState = this.dragState;
        var towards = null; // let offset

        var dragDuration = new Date() - dragState.startTime;
        var offsetLeft = dragState.currentLeft - dragState.startLeft;
        var offsetTop = dragState.currentTop - dragState.startTop;
        var offset = this.isVertical ? offsetTop : offsetLeft;
        var itemWidth = dragState.itemWidth;
        var itemHeight = dragState.itemHeight;
        var itemSize = this.isVertical ? itemHeight : itemWidth;
        var index = this.index;
        var itemCount = this.rItemCount;
        var isFastDrag = dragDuration < PAGING_DURATION;
        this.moveSpeed = Math.abs(offset) / (dragDuration / 1000);
        this.moveOffsetPercent = Math.abs(offset / itemSize); // console.log(
        //   'this.moveOffsetPercent',
        //   this.moveOffsetPercent,
        //   'offset',
        //   offset,
        //   'itemSize',
        //   itemSize
        // )

        if (isFastDrag && dragState.currentLeft === undefined) {
          this.play(this.autoplay);
          return;
        }

        if (Math.abs(offset) > itemSize * PAGING_SCALE || isFastDrag) {
          towards = offset < 0 ? 'next' : 'prev';
        } else {
          // 滑动距离过小，回到原位
          if (this.isSlide) {
            this.$_animeTranslate({
              element: this.$swiper,
              offset: this.$_getOffset(this.slideOffset - this.dimension * index, index) // offset: this.slideOffset - this.dimension * index,

            }); // this.$_translate(this.$swiper, this.slideOffset - this.dimension * index)

            this.$emit('posChange', 0);
          } else {
            this.$_opacity(true, 0);
          }
        }

        if (!this.isLoop && !this.isDragRebound) {
          if (index === 0 && towards === 'prev' || index === itemCount - 1 && towards === 'next') {
            towards = null;
          }
        } // this.$_changeTransitionMode()


        this.$_doTransition(towards);
        this.dragState = {};
        this.isNoLoopAndDragRebound && (this.preOffset = 0);
      },
      // MARK: public methods
      next: function next() {
        this.$_doTransition('next');
      },
      prev: function prev() {
        this.$_doTransition('prev');
      },
      goto: function goto(displayIndex) {
        if (isNaN(displayIndex)) {
          return;
        }

        var realIndex = this.$_calcuRealIndex(displayIndex);
        var towards = realIndex > this.index ? 'next' : 'pre';

        if (this.isTabSlide) {
          // 设置动画时间
          this.transitionDurationInside = this.realIndex || displayIndex ? 300 + Math.abs(this.realIndex - displayIndex) * 50 : 350;
        }

        this.$_doTransition(towards, {
          index: realIndex
        }); // restart timer

        this.play(this.autoplay);
      },
      getIndex: function getIndex() {
        return this.$_calcDisplayIndex(this.index);
      },
      play: function play() {
        var autoplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3000;
        this.$_clearTimer();

        if (autoplay < 500) {
          return;
        }

        this.autoplay = autoplay || this.autoplay;
        this.$_startPlay();
        this.isStoped = false;
      },
      stop: function stop() {
        this.$_clearTimer();
        this.isStoped = true;
      },
      getTransitionParams: function getTransitionParams(_ref2) {
        var _ref2$type = _ref2.type,
            type = _ref2$type === void 0 ? 'duration' : _ref2$type;
        // 获取动画模式
        var mode = this.bounceStatus ? 'bounce' : this.isTabSlide ? 'tabSlide' : this.isSlide ? 'swiper' : '';

        if (type === 'duration') {
          var durationMap = {
            swiper: 300,
            tabSlide: 300,
            bounce: 350
          };
          return durationMap[mode];
        } // console.log('mode', mode, 'this.moveSpeed', this.moveSpeed)


        if (type === 'easing') {
          var easing = ''; // spring动效

          var isSpring = this.isTurning || this.isTabSlide; // console.log('isSpring', isSpring, this.transition, this.animation)

          if (this.moveSpeed > 300 && isSpring && !this.bounceStatus) {
            easing = "spring(0.3, 200, ".concat(this.processSpeed({
              speed: this.moveSpeed,
              moveOffset: this.moveOffsetPercent,
              type: 'damping'
            }), ", ").concat(this.processSpeed({
              speed: this.moveSpeed,
              moveOffset: this.moveOffsetPercent,
              type: 'velocity'
            }), ")");
          } // 取值范围都是0-100
          // 第一个参数mass 质量，越大，惯性越大，弹性越大
          // 第二个参数stiffness 刚度，越大，弹性越大
          // 第三个参数damping 阻尼，越大，振动越小
          // 第四个参数velocity 初始速度，越大，越快、振幅越大


          var easingMap = {
            swiper: easing || "linear",
            tabSlide: easing || "cubicBezier(0.28, 0.4, 0.2, 1)",
            bounce: "cubicBezier(0.33, 1, 0.68, 1)"
          };
          return easingMap[mode];
        }
      },
      processSpeed: function processSpeed(_ref3) {
        var speed = _ref3.speed,
            moveOffset = _ref3.moveOffset,
            _ref3$type = _ref3.type,
            type = _ref3$type === void 0 ? 'damping' : _ref3$type;

        if (type === 'damping') {
          if (speed > 1000) return 8;
          if (speed < 700) return 13;else return (speed - 700) / 300 * 5 + 8;
        }

        if (type === 'velocity') {
          return moveOffset > 0.7 && speed > 1200 ? speed : 0;
        }
      },
      processWrapperWidthChange: function processWrapperWidthChange() {
        var _this11 = this;

        var ResizeNumberLimit = 5;
        if (!window.ResizeObserver || !this.autoResize) return;
        this.resizeOb = new window.ResizeObserver(function (entries) {
          var _iterator = _createForOfIteratorHelper(entries),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _entry$contentRect, _entry$contentBoxSize, _entry$contentBoxSize2;

              var entry = _step.value;
              var realWidth = (entry === null || entry === void 0 ? void 0 : (_entry$contentRect = entry.contentRect) === null || _entry$contentRect === void 0 ? void 0 : _entry$contentRect.width) || (entry === null || entry === void 0 ? void 0 : (_entry$contentBoxSize = entry.contentBoxSize) === null || _entry$contentBoxSize === void 0 ? void 0 : (_entry$contentBoxSize2 = _entry$contentBoxSize[0]) === null || _entry$contentBoxSize2 === void 0 ? void 0 : _entry$contentBoxSize2.inlineSize);

              if (realWidth && realWidth !== _this11.dimension) {
                _this11.$_resize();
              }
            } // 触发次数达到上限，不再触发

          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          _this11.resizeNumber++;

          if (_this11.resizeNumber >= ResizeNumberLimit && _this11.resizeOb) {
            _this11.unprocessWrapperWidthChange();
          }
        });
        this.resizeOb.observe(this.$refs.wrapper);
      },
      unprocessWrapperWidthChange: function unprocessWrapperWidthChange() {
        var _this$resizeOb;

        if (!window.ResizeObserver || !this.autoResize) return;
        this.$refs.wrapper && ((_this$resizeOb = this.resizeOb) === null || _this$resizeOb === void 0 ? void 0 : _this$resizeOb.unobserve(this.$refs.wrapper));
        this.resizeOb = null;
      },
      renderIndicatorsOpacity: function renderIndicatorsOpacity(pos) {
        if (!this.dragging || this.bounceStatus) {
          var domArray = this.$el.querySelectorAll('.nx-swiper-indicator');
          domArray.forEach(function (item) {
            item.style.opacity = '';
          });
          return;
        }

        var current = this.$el.querySelector(".nx-swiper-indicator-order-".concat(this.realIndex));
        var next = this.$el.querySelector(".nx-swiper-indicator-order-".concat(this.dragToIndex));

        if (current && next) {
          current.style.opacity = 0.9 - Math.abs(pos) * 0.4;
          next.style.opacity = Math.abs(pos) * 0.4 + 0.5;
        }
      },
      swiperItemCreated: function swiperItemCreated() {
        var _this12 = this;

        if (!this.ready) {
          return;
        }

        this.$nextTick(function () {
          _this12.$_clearTimer();

          _this12.$_reInitItems();

          if (_this12.autoplay > 0 && !_this12.isStoped) {
            _this12.$_startPlay();
          }
        });
      },
      swiperItemDestroyed: (0, _util.debounce)(function () {
        var _this13 = this;

        if (!this.ready) {
          return;
        }

        this.$nextTick(function () {
          _this13.$_clearTimer();

          _this13.$_reInitItems();

          if (_this13.autoplay > 0 && !_this13.isStoped) {
            _this13.$_startPlay();
          }
        });
      }, 50)
    }
  };
  _exports.default = _default;
});